import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SidebarTitleItemNextUniDriver extends BaseUniDriver {
  getText: () => Promise<string>;
  getSkin: () => Promise<string>;
}
